<template>
    <Breadcrumbs :extraData="this.nomeCatalogo"></Breadcrumbs>
    <section class="Section">
        <div class="Container">
            <div class="Box">
                <div class="SidebarHolder">
                    <div class="SidebarSx">
                        <CatalogSearch 
                            :catalogoSelected="this.catalogoSelected" 
                            :categoriaExternal = "this.categoriaSelected"
                            @ListModelReady="setListaModelli($event)">
                        </CatalogSearch>
                    </div>
                    <div class="SidebarDx">
                        <div class="LineItemHolder">
                            <Modelslist 
                                :modelsList="this.listaModelli"
                            >
                            </Modelslist>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import CatalogSearch from "@/components/Catalogsearch.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Modelslist from "@/components/Modelslist.vue";

export default{
    name: "CatalogProducts",
    data(){
        return  {
            catalogoSelected : "",
            categoriaSelected : "",
            listaModelli : []
        }
    },
    components:{
        CatalogSearch,
        Breadcrumbs,
        Modelslist
    },
    methods:{
        setListaModelli: function(event){
            this.listaModelli = event;
        },
        setCatalogo: function(catalogo){
            this.catalogoSelected = catalogo;
        },
        setModelli: function(catalogoSelected, categoriaSelected){
            this.catalogoSelected = catalogoSelected;
            this.categoriaSelected = categoriaSelected;
        }
    },
    computed:{
        nomeCatalogo: function(){
            return this.$store.getters.getCatalogName(this.catalogoSelected);
        }
    },
    created: function(){
        this.catalogoSelected = this.$route.params.idCatalog;
    },
    beforeRouteUpdate (to, from, next) {
        this.setCatalogo(to.params.idCatalog);
        next();
    },
    beforeRouteEnter (to, from, next) {
        let idCategoria = to.params.idCategoria;
        let idCatalogo = to.params.idCatalog;

        if(idCategoria){
            next(c => c.setModelli(idCatalogo, idCategoria));
        }
        else{
            next();
        }
    }
}
</script>